import React, { useState, useEffect } from "react"
import { ProfileCorporateComponent } from "./ProfileCorporateComponent";
import { ProfilePersonalComponent } from "./ProfilePersonalComponent";
import { Loading } from "../share/loading";

export function ProfileComponent() {
    const user = JSON.parse(localStorage.getItem("userData"));
    const [customerTypeId, setCustomerTypeId] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getProfileType = async () => {
            try {
                const res = await fetch("/api/Profile/getProfile", {
                    method: "POST",
                    headers: { 'token': user.token },
                });
                const resJson = await res.json();
                setCustomerTypeId(Number(resJson?.dataenum?.customerTypeId));
            } catch (e) {
                // console.log("err", e)
            } finally {
                setLoading(false);
            }
        };
        getProfileType();
    }, []);

    if (loading) { return <Loading /> }

    // customerTypeId: 1 = นิติบุคคล, 2 = บุคคลธรรมดา
    return customerTypeId === 2
        ? <ProfilePersonalComponent />
        : <ProfileCorporateComponent />;
}
